/** Same stable identities as offline backend + apps/api memory dev users */

export const MEM_ALICE_ID = "aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa";
export const MEM_BOB_ID = "bbbbbbbb-bbbb-4bbb-bbbb-bbbbbbbbbbbb";
/** Offline solo opponent — turns are resolved automatically in the offline API. */
export const MEM_CPU_ID = "cccccccc-cccc-4ccc-8ccc-cccccccccccc";

export function offlineDevLoginPayload(slug: "alice" | "bob"): {
  token: string;
  user: {
    id: string;
    displayName: string;
    profileSetupComplete: boolean;
  };
} {
  const uid = slug === "alice" ? MEM_ALICE_ID : MEM_BOB_ID;
  return {
    token: `cwf-offline-${slug}`,
    user: {
      id: uid,
      displayName: slug === "alice" ? "Alice" : "Bob",
      profileSetupComplete: true,
    },
  };
}
